import api from "./axios";
import { apiPaths } from "./paths";
import type { ReactionKind } from "@/constants/reaction-kind";
import type { Reaction, ReactionSummary } from "@/types";

export const getReactionSummary = (articleId: string) =>
  api
    .get<ReactionSummary>(apiPaths.articles.reactions.summary(articleId))
    .then((r) => r.data);

export const upsertReaction = (articleId: string, type: ReactionKind) =>
  api
    .post<Reaction>(apiPaths.articles.reactions.collection(articleId), {
      type,
    })
    .then((r) => r.data);

export const removeReaction = (articleId: string) =>
  api.delete(apiPaths.articles.reactions.collection(articleId));
